import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f0f2f5',
  },
  contentWrapper: {
    padding: 24,
  },
  filterSection: {
    backgroundColor: 'white',
    padding: 16,
    borderRadius: 8,
    marginBottom: 24,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#d9d9d9',
    borderRadius: 4,
    backgroundColor: 'white',
    width: 80,
  },
  picker: {
    width: 80,
    height: 40,
  },  projectCard: {
    backgroundColor: 'white',
    borderRadius: 8,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    overflow: 'hidden',
  },
  projectHeader: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  projectTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12,
    flexWrap: 'wrap',
    width: '100%', // 전체 너비 사용
  },
  projectTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  projectPercent: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  statusIndicator: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  dangerIndicator: {
    backgroundColor: '#ff4d4f',
  },
  warningIndicator: {
    backgroundColor: '#faad14',
  },
  goodIndicator: {
    backgroundColor: '#52c41a',
  },
  statusText: {
    fontSize: 14,
    fontWeight: '500',
  },
  dangerText: {
    color: '#ff4d4f',
  },
  warningText: {
    color: '#faad14',
  },
  goodText: {
    color: '#52c41a',
  },
  expectedProgress: {
    fontSize: 13,
    color: '#666',
  },
  redmineButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
    backgroundColor: '#f0f0f0',
  },
  redmineText: {
    fontSize: 13,
    color: '#333',
  },
  projectMeta: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  projectInfo: {
    flexDirection: 'column',
    gap: 8,
  },
  infoRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },  infoItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoLabel: {
    fontSize: 12,
    color: '#999',
    marginRight: 4,
  },
  infoValue: {
    fontSize: 14,
    color: '#666',
  },
  expandButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 4,
    backgroundColor: '#1890ff',
  },
  expandButtonText: {
    color: 'white',
    fontSize: 14,
    fontWeight: '500',
  },
  timelineSection: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  progressSection: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  progressTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
    color: '#333',
  },  newsSection: {
    padding: 20,
  },
  newsTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 12,
    color: '#333',
  },
  newsContent: {
    backgroundColor: '#f8f9fa',
    padding: 16,
    borderRadius: 4,
    borderLeftWidth: 4,
    borderLeftColor: '#1890ff',
  },
  newsDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
    marginBottom: 8,
  },
  attachmentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    padding: 8,
    backgroundColor: 'white',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  attachmentIcon: {
    fontSize: 16,
    marginRight: 8,
  },
  attachmentLink: {
    fontSize: 13,
    color: '#1890ff',
    textDecorationLine: 'underline',
  },
});